import { addWindowResizeListener } from '../../../common/utils/domEvents';

const defaultConfig = {
  draggable: true,
  overflowing: true,
};
const stopAllEventsFunctionName = 'stopAllDragScrollEvents';

const stopAllEvents = (el) => {
  el[stopAllEventsFunctionName]?.();
};

const dragScrollEvents = (el) => {
  const target = el;
  let isDown = false;
  let startX;
  let scrollLeft;

  const onMouseDown = (e) => {
    isDown = true;
    target.classList.add('is-dragging');
    startX = e.pageX - target.offsetLeft;
    scrollLeft = target.scrollLeft;
  };

  const onMouseUp = () => {
    isDown = false;
    target.classList.remove('is-dragging');
  };

  const onMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - target.offsetLeft;
    target.scrollLeft = scrollLeft - (x - startX) * 1.5;
  };

  return {
    start() {
      target.addEventListener('mousedown', onMouseDown);
      target.addEventListener('mouseleave', onMouseUp);
      target.addEventListener('mouseup', onMouseUp);
      target.addEventListener('mousemove', onMouseMove);
    },
    stop() {
      target.removeEventListener('mousedown', onMouseDown);
      target.removeEventListener('mouseleave', onMouseUp);
      target.removeEventListener('mouseup', onMouseUp);
      target.removeEventListener('mousemove', onMouseMove);
    },
  };
};

const overflowingEvents = (el) => {
  const target = el;
  let resizeRemoveEvent;

  const onScroll = () => {
    // change overflowing left state
    if (target.scrollLeft > 0) target.classList.add('overflowing-left');
    else target.classList.remove('overflowing-left');

    // change overflowing right state
    if (
      Math.abs(target.scrollWidth - target.scrollLeft - target.offsetWidth) >= 1
    )
      {target.classList.add('overflowing-right');}
    else target.classList.remove('overflowing-right');
  };

  return {
    start() {
      target.addEventListener('scroll', onScroll, {
        passive: true,
      });
      onScroll();
      resizeRemoveEvent = addWindowResizeListener(onScroll);
    },
    stop() {
      target.removeEventListener('scroll', onScroll);
      resizeRemoveEvent?.();
    },
  };
};

const init = (el, options) => {
  const target = el;
  const config = {
    ...defaultConfig,
    ...(typeof options === 'object' ? options : {}),
  };

  if (!target) return;

  // stop all events if exists
  stopAllEvents(target);

  const dragScroll = dragScrollEvents(target);
  if (config.draggable) dragScroll.start();

  const overflowing = overflowingEvents(target);
  if (config.overflowing) overflowing.start();

  // create stop events function
  target[stopAllEventsFunctionName] = () => {
    dragScroll.stop();
    overflowing.stop();
  };
};

export default {
  inserted(el, { value }) {
    init(el, value);
  },
  update(el, { value, oldValue }) {
    // update the component only if the parameters change
    if (JSON.stringify(value) === JSON.stringify(oldValue)) return;
    init(el, value);
  },
  unbind(el) {
    stopAllEvents(el);
  },
};
